import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-pagination-list-footer',
    templateUrl: './pagination-list-footer.component.html',
    styleUrl: './pagination-list-footer.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass]
})
export class PaginationListFooterComponent implements OnInit, OnChanges {
  @Input() totalPages: number = 0;
  @Input() currentPage: number = 1;

  @Output() goToPage = new EventEmitter<number>();

  pages: number[] = [];

  loading = true;
  ngOnInit(): void {
    this.loading = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalPages'] || changes['currentPage']) {
      this.pages = this.getDisplayedPages();
    }
  }

  onGoToPage(page: number) {
    if(page < 1) return this.goToPage.emit(1);
    if(page > this.totalPages) return this.goToPage.emit(this.totalPages);
    this.goToPage.emit(page);
  }

   getDisplayedPages(): number[] {
    const pages: number[] = [];
    let startPage = this.currentPage - 2;
    let endPage = this.currentPage + 2;
  
    // Adjust start and end pages if they go out of bounds
    if (startPage < 1) {
      endPage += 1 - startPage;
      startPage = 1;
    }
    if (endPage > this.totalPages) {
      startPage -= endPage - this.totalPages;
      endPage = this.totalPages;
    }
  
    // Ensure startPage is at least 1 and endPage is at most totalPages
    startPage = Math.max(1, startPage);
    endPage = Math.min(this.totalPages, endPage);
  
    // Generate the pages array
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
  
    return pages;
  }
}
